import { STATUS_COLORS } from "../theme/theme";

type StatusColorKey = keyof typeof STATUS_COLORS;

/** Pre-built MUI Chip sx overrides using STATUS_COLORS tokens */
export const CHIP_COLOR_OVERRIDES = {
  "&.MuiChip-colorError": {
    backgroundColor: STATUS_COLORS.error.bg,
    borderColor: STATUS_COLORS.error.border,
    color: STATUS_COLORS.error.text,
  },
  "&.MuiChip-colorWarning": {
    backgroundColor: STATUS_COLORS.warning.bg,
    borderColor: STATUS_COLORS.warning.border,
    color: STATUS_COLORS.warning.text,
  },
  "&.MuiChip-colorInfo": {
    backgroundColor: STATUS_COLORS.info.bg,
    borderColor: STATUS_COLORS.info.border,
    color: STATUS_COLORS.info.text,
  },
  "&.MuiChip-colorDefault": {
    backgroundColor: STATUS_COLORS.default.bg,
    borderColor: STATUS_COLORS.default.border,
    color: STATUS_COLORS.default.text,
  },
  "&.MuiChip-colorSuccess": {
    backgroundColor: STATUS_COLORS.success.bg,
    borderColor: STATUS_COLORS.success.border,
    color: STATUS_COLORS.success.text,
  },
} as const;

/** Look up a STATUS_COLORS triad by chip color name */
export const getChipColors = (color: string) =>
  STATUS_COLORS[color as StatusColorKey] ?? STATUS_COLORS.default;
